// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentUpdateRequestModel {
    static getAttributeTypeMap() {
        return EnrollmentUpdateRequestModel.attributeTypeMap;
    }
}
EnrollmentUpdateRequestModel.discriminator = undefined;
EnrollmentUpdateRequestModel.attributeTypeMap = [
    {
        "name": "insuranceVerification",
        "baseName": "insuranceVerification",
        "type": "EnrollmentInsuranceVerificationModel"
    },
    {
        "name": "demographics",
        "baseName": "demographics",
        "type": "EnrollmentDemographicsModel"
    },
    {
        "name": "clientIdentifiers",
        "baseName": "clientIdentifiers",
        "type": "EnrollmentClientIdentifiersModel"
    }
];
//# sourceMappingURL=enrollmentUpdateRequestModel.js.map